import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface CleanIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
}

export const CleanIcon: FunctionComponent<CleanIconProps> = ({
  className,
  isInvertedTheme,
  ...props
}) => {
  const theme = useTheme();

  const getBGColor = () => {
    if (isInvertedTheme) {
      return theme.colors.primary;
    }

    return theme.colors.secondary;
  };

  const getPathColor = () => {
    if (isInvertedTheme) {
      return theme.colors.secondary;
    }

    return theme.colors.primary;
  };

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className || ''}
      {...props}
    >
      <rect fill={getBGColor()} width="16" height="16" rx="4" ry="4" />
      <path
        fill={getPathColor()}
        d="M8.77,4.5c.42,0,.78,.06,1.08,.18s.57,.27,.8,.47v1.4c-.16-.12-.32-.24-.5-.35s-.37-.21-.58-.28-.47-.11-.76-.11c-.4,0-.76,.1-1.08,.29s-.58,.45-.78,.78-.29,.7-.29,1.12,.1,.78,.29,1.11,.45,.59,.78,.78,.69,.28,1.08,.28c.44,0,.82-.07,1.12-.2s.58-.31,.82-.5v1.35c-.23,.21-.51,.37-.85,.5s-.72,.18-1.13,.18c-.48,0-.93-.08-1.35-.26s-.8-.41-1.12-.72-.58-.68-.77-1.1-.28-.9-.28-1.42,.09-.99,.28-1.42,.44-.8,.77-1.1,.7-.55,1.12-.72,.88-.26,1.35-.26Z"
      />
    </svg>
  );
};

export default CleanIcon;
